<template>
  <div class="buy">
    <div class="goodSearch">
      <van-search
        v-model="goodSku"
        placeholder="请输入商品条码"
        @search="searchBySku"
        show-action
      >
        <template #action>
          <div @click="searchBySku">搜索</div>
        </template>
      </van-search>
      <van-card
        v-if="showGood"
        :price="goodInfo.price"
        :desc="goodInfo.remarks"
        :title="goodInfo.name"
        :thumb="goodInfo.coverImg"
      >
        <template #num>
          <div style="float: left">
            <van-icon
              name="shopping-cart"
              @click="addToCard"
              color="rgb(195, 156, 113)"
              size="25px"
            />
          </div>
        </template>
      </van-card>
      <div class="addToCart"></div>
    </div>
    <div class="shopcart" v-on:click="toShopcart">
      <van-icon name="cart-circle" size="33" color="#C39C71" :badge="cartNum" />
    </div>
    <div class="scanDiv" v-on:click="doScan">
      <div class="scan-icon">
        <van-icon name="scan" style="margin-top:17px;" size="30" />
      </div>
    </div>
  </div>
</template>

<script>
import "../../assets/css/buy.less";
import { queryPost, apiPost, setWxConfig } from "@/api/common";
import wx from "weixin-js-sdk";

export default {
  name: "Buy",
  data() {
    return {
      success: true,
      showPopup: false,
      showGood: false,
      goodSku: "",
      buyNumber: 1,
      cartNum: "",
      goodInfo: {},
      shopInfo: {},
      cardInfo: {}
    };
  },
  components: {},
  created() {
    this.loadComments();
    this.getCartCount();
  },
  methods: {
    loadComments() {
      // debugger
      let s = sessionStorage.getItem("shopInfo");
      let c = sessionStorage.getItem("cardInfo");
      this.shopInfo = s ? JSON.parse(s) : "";
      this.cardInfo = c ? JSON.parse(c) : "";

      wx.error(function(res) {
        // config 信息验证失败会执行error函数,如签名过期导致验证失败,具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
        setWxConfig(window.location.href);
        console.log(res.errMsg);
      });
      // wx.ready;
    },

    doScan() {
      let _this = this;
      /* 处理失败验证 */

      wx.ready(function() {
        wx.checkJsApi({
          jsApiList: ["scanQRCode"],
          success: function(res) {
            // 以键值对的形式返回，可用true，不可用false。如：{"checkResult":{"scanQRCode":true},"errMsg":"checkJsApi:ok"}
            if (res.checkResult.scanQRCode === true) {
              wx.scanQRCode({
                // 微信扫一扫接口
                desc: "scanQRCode desc",
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function(res) {
                  const getCode = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  _this.goodSku = getCode.split(",")[1];
                  _this.searchBySku();
                  // _this.$toast.fail(getCode);
                }
              });
            } else {
              alert("抱歉，当前客户端版本不支持扫一扫");
            }
          },
          fail: function(res) {
            // 检测getNetworkType该功能失败时处理
            alert("fail" + res);
          }
        });
      });
    },
    getCartCount() {
      let _this = this;
      let url = "/api/order/selectShoppingCart";
      let data = {
        code: this.shopInfo.shopCode,
        mobile: this.cardInfo.tel
      };
      apiPost(url, data)
        .then(resp => {
          let _data = resp.data;
          if (_data.code == "0000") {
            this.cartNum = _data.data.results.totalNum;
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    changeShowPopup() {
      this.showPopup = !this.showPopup;
    },
    searchBySku() {
      let _this = this;
      let url = "/api/order/getProductInfo";
      let data = {
        code: _this.goodSku
      };
      queryPost(url, data)
        .then(resp => {
          let _data = resp.data;
          if (_data.code == "0000") {
            _this.goodInfo = _data.data.results;
            _this.showGood = true;
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //加入购物车
    addToCard() {
      let _this = this;
      let url = "/api/order/addShoppingCart";
      let data = {
        cardNumber: "",
        code: this.shopInfo.shopCode,
        goodsSukId: this.goodSku,
        mobile: this.cardInfo.tel,
        name: this.goodInfo.name,
        isCheck: 0,
        num: 1,
        price: this.goodInfo.price,
        coverImg: this.goodInfo.coverImg,
        remarks: this.goodInfo.remarks
      };
      apiPost(url, data)
        .then(resp => {
          let _data = resp.data;
          if (_data.code == "0000") {
            _this.$toast.success("添加购物车成功!");
            this.getCartCount();
          } else {
            _this.$toast.fail(_data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    toShopcart() {
      this.$router.push("shopcart");
    },
    toSettle() {
      this.$router.push("settle");
    }
  }
};
</script>
